import React from 'react';
import './Loader.scss';

function Loader({ size,color = 'default' }) {
  let loaderClass = 'load-4';
  if (size === 'small') {
    loaderClass += ' small';
  } else if (size === 'button-loader') {
    loaderClass += ' button-loader'; // Add button-loader size class
  }

  const colorClass = color === 'default' ? 'default-color' : 'white-color';

  return (
     <div className={`${loaderClass} ${colorClass}`}> 
      <div className="ring-1"></div>
    </div>
  );
}

export default Loader;